import React from 'react';
import { useHistory } from 'react-router';

import Grid from '@material-ui/core/Grid';

import Success from '@components/SuccessRefund';
import * as ROUTES from '@constants/routes';
import RefundCard from '@components/RefundCard';
import PdfRefund from '@components/PdfRefund';
import { saveReactToPdf } from '@helpers/exportPdf';
import { useAuth, useTransaction } from '@hooks';

export const SuccessRefund = () => {
  const ref = React.createRef();

  const history = useHistory();
  const handleClick = () => {
    history.push(ROUTES.TRANSACTIONS);
  };

  const { isAllowed } = useAuth();
  const { currentRefund } = useTransaction();

  const permissionDonwloadPdf = isAllowed('TRANSACTIONS_REFUND_PDF_DOWNLOAD');

  const fileName = `refund-of-${
    currentRefund ? currentRefund?.transactionOriginal?.authorization_id : 'transaction'
  }.pdf`;

  const handleDownload = () => saveReactToPdf(ref, { fileName, x: 30 });

  return (
    <Grid container data-testid="success-refund">
      <Success handleDownload={permissionDonwloadPdf && handleDownload} handleClick={handleClick}>
        <RefundCard />
      </Success>
      {permissionDonwloadPdf && <PdfRefund refElement={ref} />}
    </Grid>
  );
};

export default SuccessRefund;
